import { render } from "./ReportRouting.vue?vue&type=template&id=71e1e0ad&scoped=true"
import script from "./ReportRouting.vue?vue&type=script&lang=js"
export * from "./ReportRouting.vue?vue&type=script&lang=js"

import "./ReportRouting.vue?vue&type=style&index=0&id=71e1e0ad&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e1e0ad"]])

export default __exports__